import { render, staticRenderFns } from "./BulletinNotificationComponent.vue?vue&type=template&id=411d9fc0&scoped=true&"
import script from "./BulletinNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinNotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinNotificationComponent.vue?vue&type=style&index=0&id=411d9fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411d9fc0",
  null
  
)

export default component.exports